import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"
import Image from "gatsby-image"

class ImageBlock extends Component {
  render() {
    const content = this.props.content
    const blogPost = this.props.blogPost
    const sectionClasses = helpers.sectionClasses(
      content.sectionOptions,
      blogPost
    )

    const largeImageSrc = {
        fluid: content.image?.localFile?.childImageSharp?.fluid,
        alt: content.image?.altText,
    }
    
    if (content.image) {
      return (
        <section className={`${sectionClasses}`}>
          <div className="container">
            <div className="w-full flex justify-center">
              <div className="w-full lrg:w-8/12 lrg:px-6 article-body content-block">
                <Image
                    fluid={largeImageSrc.fluid}
                    alt={largeImageSrc.alt}
                    className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </section>
      )
    } else {
      return <p>.</p>
    }
  }
}

export default ImageBlock
